import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from 'rxjs';

@Injectable()
export class TransportInterestService {
  private apiUrl = `${environment.API_URL}/transport-interest`;

  constructor(private http: HttpClient) {}

  getDemandDetails(demandId: number, token: string): Observable<any> {
    return this.http.get(`${this.apiUrl}/${demandId}/${token}`);
  }

  submitInterest(formData: any): Observable<any> {
    //console.log("formData", formData);
    return this.http.post(`${this.apiUrl}/submit-interest`, formData);
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/_services/transport-interest.service.ts